import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

function getArticleImage(id: number): string {
  if (id === 1) return 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20livestream%20setup%20with%20neon%20ring%20light%20falling%20over%2C%20shattered%20makeup%20products%20on%20a%20dark%20floor%2C%20dim%20moody%20lighting%20with%20pink%20and%20cyan%20accents%2C%20cinematic%20composition%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20moody%20atmosphere%2C%20simple%20dark%20background&width=800&height=500&seq=daily-news-1&orientation=landscape';
  if (id === 2) return 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20paparazzi%20camera%20flash%20effect%2C%20sleek%20black%20car%20pulling%20up%2C%20dramatic%20noir%20lighting%20with%20neon%20city%20reflections%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20with%20deep%20contrast%20and%20moody%20atmosphere%2C%20dark%20urban%20background&width=800&height=500&seq=daily-news-2&orientation=landscape';
  if (id === 3) return 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20lighting%2C%20two%20silhouettes%20confronting%20each%20other%20on%20stage%2C%20cameras%20and%20crew%20in%20background%20blurred%2C%20intense%20atmosphere%20with%20spotlight%20beams%20cutting%20through%20haze%2C%20cinematic%20documentary%20style%2C%20dark%20studio%20background&width=800&height=500&seq=daily-news-3&orientation=landscape';
  if (id === 5) return 'https://readdy.ai/api/search-image?query=Corporate%20office%20building%20at%20night%20with%20lights%20flickering%20dramatically%2C%20stock%20market%20charts%20showing%20sharp%20decline%20on%20dark%20screens%2C%20emergency%20documents%20scattered%20on%20desk%2C%20noir%20thriller%20atmosphere%20with%20cyan%20and%20red%20accent%20lighting%2C%20cinematic%20composition%2C%20dark%20corporate%20environment&width=800&height=500&seq=daily-news-5&orientation=landscape';
  if (id === 6) return 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20a%20dark%20reflective%20surface%20with%20broken%20heart%20neon%20sign%20reflection%2C%20shattered%20glass%20effect%2C%20messy%20breakup%20atmosphere%20with%20scattered%20polaroid%20photos%2C%20moody%20pink%20and%20cyan%20lighting%2C%20editorial%20still%20life%20photography%2C%20dark%20background&width=800&height=500&seq=daily-news-6&orientation=landscape';
  return 'https://readdy.ai/api/search-image?query=Dark%20moody%20news%20photography%20scene%20with%20dramatic%20lighting%2C%20abstract%20composition%20with%20pink%20and%20cyan%20neon%20accents%2C%20editorial%20atmosphere%2C%20clean%20dark%20background%20with%20subtle%20texture&width=800&height=500&seq=daily-news-fallback&orientation=landscape';
}

export default function DailyNews() {
  const navigate = useNavigate();
  const hotArticles = articles.filter((a) => a.hot).slice(0, 6);

  return (
    <section id="daily-news" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
              每日大瓜精选
            </h2>
            <p className="text-sm md:text-base text-foreground-300 mt-2">
              今日最热爆料，一网打尽
            </p>
          </div>
          <a
            href="/category/zuixin-dagua"
            onClick={(e) => { e.preventDefault(); navigate('/category/zuixin-dagua'); }}
            className="inline-flex items-center gap-2 text-primary-400 text-sm font-medium hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article, index) => (
            <article key={article.id} className="group bg-background-200 border border-background-300 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-300 hover:border-background-400">
              <a
                href={`/article/${article.id}`}
                onClick={(e) => { e.preventDefault(); navigate(`/article/${article.id}`); }}
                className="block cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={getArticleImage(article.id)}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading={index < 3 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute top-3 left-3 flex gap-2">
                    {article.hot && (
                      <span className="px-2.5 py-1 rounded-full bg-primary-500 text-foreground-50 text-xs font-medium whitespace-nowrap">
                        热门
                      </span>
                    )}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                    <span className="text-foreground-100 text-xs whitespace-nowrap">
                      {article.views.toLocaleString()} 次围观
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-50 mb-2 line-clamp-2 leading-snug group-hover:text-primary-400 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-300 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="whitespace-nowrap">{article.date}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i>
                      {article.comments.toLocaleString()} 评论
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}